import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-position-icon',
  templateUrl: './design-position.component.html'
})
export class DesignPositionComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
